export const fetchImageData = async (imageId: string): Promise<string> => {
    const response = await fetch(
        `https://wp.sirendigital.uk/space-industrial/wp-json/wp/v2/media/${imageId}`
    );
    const imageData = await response.json();    
    return imageData.link;
};

export const fetchFileData = async (imageId: string): Promise<string> => {
    const response = await fetch(
        `https://wp.sirendigital.uk/space-industrial/wp-json/wp/v2/media/${imageId}`
    );
    const imageData = await response.json();   
    console.log(imageData);
    return imageData;
};

export const cleanSlug = (slug: string) => {
    return slug
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "");
};
